export default "__VITE_ASSET__COXHz1nA__"